const convertStringToHTML = (input) => {
    const formattedInput = input
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, '&');

    const textarea = document.createElement('textarea');
    textarea.innerHTML = formattedInput;

    return textarea.value;
}

export default convertStringToHTML;
